/*
 * Public API Surface of ngx-marquee
 */

export * from './lib/ngx-marquee.component';
export * from './lib/ngx-marquee.module';
